import React, { useState, useRef } from "react";
import { Button, Dialog, DialogContent, DialogActions, DialogTitle, DialogContentText } from '@mui/material';
import TextField from '@mui/material/TextField';
import Modal from 'react-bootstrap/Modal';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

const NewAirportModal = (props) => {

  const { airports: listAirports } = useSelector((state) => state.airports);
  const [active, setActive] = useState(true);
  const [name, setName] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
 
    if (props.show && props.selectedAirport != null && !loaded) {
      const filtered = listAirports.filter((airport) => { return airport.id === props.selectedAirport.id; });
      filtered.map(
        (airport) => (
          setActive(airport.active),
          setName(airport.name),
          setLoaded(true)
        )
      );
    }
    if (!props.show) {
      clearUI();
    }
  });

  const clearUI = () => {
    setLoaded(false);
    setName("");
    setActive(true);
    props.setSelectedAirport(null);
  }

  const handleSubmit = () => {
    let airport_tmp = props.selectedAirport;
    airport_tmp.name = name;
    airport_tmp.active = active;

    props.setSelectedAirport(airport_tmp);
    props.handleSubmit();
    clearUI();
  }

  return (
    <Modal {...props} size="s" centered>

      <Modal.Body>
        <Grid container spacing={1}>
          <Grid item xs={9}>
            <label htmlFor="name">Name</label>
          </Grid>
          <Grid item xs={3}>
            <FormControlLabel control={<Switch onChange={(e) => setActive(e.target.checked)} checked={active} />} label="Active" />
          </Grid>
        </Grid>

        <Input
          type="text"
          className="form-control"
          name="locality"
          size="small"
          value={name}
          onChange={(e) => setName(e.target.value)}>
        </Input>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="contained" onClick={handleSubmit} fullWidth>
          Submit
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default NewAirportModal;